// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"98e97ee0a98e101b","7370":"87b5b0e405ad13e1"}[chunkId] + ".css";
};